
const idRolVigilant = 1;
const idRolAdministrador = 3;
const idRolCECAT = 4;
const idRolObservador = 5;
const idRolObservadorVigilant = 6;
const idRolHistoric = 7;

export const rolsPermesosAccedirSeccioEstacions = [3];
export const rolsPermesosAccedirSeccioUsuaris = [3];

export const esPotAccedirSeccioEstacions = (idUsuari, idRol) => rolsPermesosAccedirSeccioEstacions.includes(idRol);
export const esPotAccedirSeccioUsuaris = (idUsuari, idRol) => rolsPermesosAccedirSeccioUsuaris.includes(idRol);

const rolsPermesosInserirComentari = [idRolVigilant, idRolAdministrador, idRolCECAT, idRolObservadorVigilant];
export const esPotInserirComentari = (idUsuari, idRol) => rolsPermesosInserirComentari.includes(idRol);

export const rolsPermesosCrearAvis = [idRolVigilant, idRolAdministrador, idRolObservadorVigilant];
export const esPotCrearAvis = (idUsuari, idRol) => rolsPermesosCrearAvis.includes(idRol);

export const rolsPermesosCrearObservacio = [idRolAdministrador, idRolObservador, idRolObservadorVigilant];
export const esPotCrearObservacio = (idUsuari, idRol) => rolsPermesosCrearObservacio.includes(idRol);

export const esPotEliminarComentari = (idUsuariComentari) => (idUsuari, idRol) => idRol === idRolAdministrador || (idUsuari === idUsuariComentari);

export const rolsPermesosAssociablesAUnaEstacio = [idRolObservador, idRolObservadorVigilant, idRolHistoric];

export const esPotEditarEliminarAvis = (dataActual, dataAvis, idVigilant) => {
    const numDiesEditable = 30;
    const estaDinsPeriodeEditable = dataActual.diff(dataAvis, 'days') <= numDiesEditable;

    return (idUsuari, idRol) => {
        const esUsuariAdministrador = idRol === idRolAdministrador;
        const esCreadorAvis = idVigilant === idUsuari;

        if (esUsuariAdministrador || (esCreadorAvis && estaDinsPeriodeEditable)) {
            return true;
        }
    };
};

export const esPotSeleccionarVigilantEnIntroduccioAvis = (idUsuari, idRol) => idRol === idRolAdministrador;



// WEBPACK FOOTER //
// ./src/commons/callbacksSeguretat.js